import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class Assistant {
    HttpAdapter = new HttpAdapter();
    baseUrlAssistant = `${publicSettings.aws.baseUrls.assistant}`;

    async getSingleUsePreSignedUrl(key, bucket) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlAssistant}/assistant/bucket/get-signed-url-by-key`,
                {
                    key,
                    bucket
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    async listObjectsInBucket({ bucket, prefix, continuationToken, maxKeys }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlAssistant}/assistant/bucket/list-objects`,
                {
                    bucket,
                    prefix,
                    continuationToken,
                    maxKeys
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    async putObjectInBucket({
        bucket,
        key,
        fileBase64,
        contentType,
        metadata
    }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlAssistant}/assistant/bucket/put-object`,
                {
                    bucket,
                    key,
                    fileBase64,
                    contentType,
                    metadata
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    }
}
